<template>
  <div style="width:100%;float:left;">
    <CWidgetDropdown color="gradient-danger" :header="'' + (data.length + saved.length)" text="Queue">
      <template #footer>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
          <CLink
            class="font-weight-bold font-xs btn-block text-danger"
            @click="viewOrders()"
          >
            View Orders
            <CIcon name="cil-arrowRight" class="float-right" width="16"/>
          </CLink>
        </CCardFooter>
      </template>
    </CWidgetDropdown>
    <CModal
      title="New Orders"
      :show.sync="viewModal"
      size="lg"
    >
      <div style="width:100%;float:left;">
        <h4 style="width:100%;float:left;text-align:center;font-size:13px;">Click to go to order.</h4>
        <table class="table" v-if="data">
          <thead>
            <tr>
              <td>Order#</td>
              <td>Rep</td>
              <td>Cust</td>
              <td>Log</td>
              <td>Status</td>
              <td>Date</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in data" @click="goToOrder(val)" :style="configureStyle(val)">
              <td>{{val.order_id}}</td>
              <td>{{val.order.rep.name}}</td>
              <td>{{val.order.customer_info.customer_name}}</td>
              <td>{{val.as400_log_number}}</td>
              <td>{{val.as400_status}}</td>
              <td>{{val.local_created_at}}</td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="val in saved" @click="goToSavedOrder(val)" style="background-color:#39f;color:#fff;">
              <td>{{val.name}}</td>
              <td>{{val.saved_by}}</td>
              <td>{{val.customer_name}}</td>
              <td></td>
              <td></td>
              <td>{{val.local_created_at}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.configureStyle = function (val) {
  if (val.as400_status === 'Needs Ship To') {
    return 'background-color:#ff8178;'
  } else {
    return ''
  }
}

methods.getNewOrders = function () {
  const postData = {
    csr: this.csr
  }
  axios.post(this.$apiAdress + '/api/orders/getCsrQueue?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log(res)
    this.data = res.data.res
    this.saved = res.data.saved
    this.$emit('set', 'csr_queue')
  }).catch(e => {
    console.log(e)
  })
}

methods.goToSavedOrder = function (val) {
  this.$router.push('/create_order/' + val.id + '/saved')
}

methods.goToOrder = function (val) {
  this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
}

methods.viewOrders = function () {
  this.viewModal = true
}

export default {
    // ===Component name
    name: "CsrQueue",
    // ===Props passed to component
    props: ['csr'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: [],
          viewModal: false,
          saved: []
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getNewOrders()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
